module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/ticket-03fd51a6880610f0b02ff982220bf243.svg&quot;;"